import React from 'react'
import Modal from 'react-bootstrap/Modal'

export default class DocumentsPresentation extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show: props.show
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let {
      show,
    } = this.state

    return (
      <Modal
        show={show}
        onHide={() => this.props.onHide()}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Customs have requested for the documents to be mailed.
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          className='scroll-y mx-5 mx-xl-15 '
        >

          <div className='text-center pt-5'>
            <div className='buttons-grid gg-7'>

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.props.onConfirm()}
              >
                Confirm
              </button>
            </div>
          </div>


        </Modal.Body>

      </Modal>
    )
  }
}
